import React from 'react';
import { useIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
// Core components
import Tooltip from 'components/core/Tooltip';
// Models
import mDevice from 'models/device';
// Custom
import { deviceSlaveTriggerDataShape } from 'constants/PropTypesShapes';
import { joinNonEmpty } from 'utils/Tools';
import InformationItem from 'components/items/InformationItem';
import AppIcon from 'components/icons/AppIcon';

const TriggerItem = ({
  deviceLabel, trigger, showToggle, toggled, onToggle, ...otherProps
}) => {
  const intl = useIntl();
  if (trigger) {
    const { equipment } = trigger;
    const value = equipment ? equipment.name : <LocalizedMessage id="info.deviceSlaveTrigger" values={{ triggerType: trigger.type }} />;

    const { type: ethernetType } = mDevice.virtualTriggerEthernet;
    let ipAddress = '';
    let rightIcon;
    if (equipment && trigger.type === ethernetType) {
      ipAddress = equipment.ip;
      const equStatus = mDevice.slaveTriggerEquipmentStatus(equipment);
      if (equStatus) {
        const { labelId, icon, color } = equStatus;
        rightIcon = (
          <Tooltip content={<LocalizedMessage id={labelId} />}>
            <AppIcon color={color} id={icon} />
          </Tooltip>
        );
      }
    }

    const triggerLabel = mDevice.triggerCanHaveEquipement(trigger) ? intl.formatMessage({ id: 'info.deviceSlaveTriggerEquipment' }, { triggerType: trigger.type, ipAddress }) : '';
    let additionalCameraLabel = null;
    if (_get(trigger, 'equipment.type') === 'license_plate_reader' && _get(trigger, 'equipment.brand', null) && _get(trigger, 'equipment.model', null)) additionalCameraLabel = `${trigger.equipment.brand} - ${trigger.equipment.model}`;
    let label = joinNonEmpty([deviceLabel, triggerLabel], ' - ');
    if (additionalCameraLabel) {
      label = (
        <div>
          <div>{label}</div>
          <div>{additionalCameraLabel}</div>
        </div>
      );
    }

    return (
      <InformationItem
        label={label}
        value={value}
        icon={mDevice.triggerIcon(trigger)}
        withAvatar
        toggle={showToggle ? { toggled, onToggle } : null}
        rightIcon={rightIcon}
        {...otherProps}
      />
    );
  }
  return null;
};

TriggerItem.propTypes = {
  deviceLabel: PropTypes.string,
  trigger: deviceSlaveTriggerDataShape,
  showToggle: PropTypes.bool,
  toggled: PropTypes.bool,
  onToggle: PropTypes.func,
};

TriggerItem.defaultProps = {
  deviceLabel: null,
  trigger: null,
  showToggle: false,
  toggled: false,
  onToggle: null,
};

module.exports = TriggerItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/TriggerItem.js